import React from 'react';

const organizations = [
  {
    name: 'Alison',
    url: 'https://alison.com/?utm_source=alison_user&utm_medium=affiliates&utm_campaign=30620902',

    desc: 'Thousands of certificates and diplomas in most sectors'
  },
  {
    name: 'Ikamva Solutions',
    url: 'https://ikamvasolutions.co.za/',
    desc: 'Leadership Coaching; Management Consulting; Fractional HC; Change Management; Employee Relations; Resourcing; HC Consulting; Talent Management; HC Governance & Compliance.'
  },
  {
    name: 'Symphonia Leadership Development',
    url: 'https://www.symphonia.net/',
    desc: 'An Organisational Change Practice that works with leaders to engage their stakeholders so that talent, human energy and creativity is maximised.'
  }
];

export default function Organizations() {
  return (
    <div style={{ padding: 24, maxWidth: 1200, margin: '0 auto' }}>
      <h2 style={{ color: '#333', borderBottom: '2px solid #ccbc74', paddingBottom: 10, marginBottom: 20 }}>Organisation Partners</h2>
      <ul style={{ listStyle: 'none', padding: 0 }}>
        {organizations.map((org) => (
          <li key={org.name} style={{ marginBottom: 24, padding: 16, borderRadius: 8, boxShadow: '0 2px 8px rgba(0,0,0,0.1)' }}>
            <h3 style={{ marginTop: 0, color: '#444' }}>{org.name}</h3>
            <p style={{ color: '#666', marginBottom: 12 }}>{org.desc}</p>
            <a 
              href={org.url} 
              target="_blank" 
              rel="noopener noreferrer"
              style={{ 
                color: '#ccbc74', 
                textDecoration: 'none', 
                fontWeight: 500,
                display: 'inline-block',
                borderBottom: '1px solid transparent',
                transition: 'border-color 0.3s'
              }}
              onMouseOver={(e) => e.target.style.borderBottomColor = '#ccbc74'}
              onMouseOut={(e) => e.target.style.borderBottomColor = 'transparent'}
            >
              Visit Website
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
} 